/* eslint-env browser */
import { getAnonymousLdClient } from '../shared/ldAnonymousClient';

/**
 * Updates the terms of use link based on LaunchDarkly feature flag
 * If the flag is disabled, revert to English terms even if cookie says Spanish
 */
export function updateTermsLink() {
  const termsLinks = [
    document.getElementById('terms-of-use-link'),
    document.getElementById('terms-of-use-link-onboarding'),
    document.getElementById('privacy-policy-link')
  ].filter(Boolean);

  if (termsLinks.length === 0) return;

  const ldClient = getAnonymousLdClient();

  ldClient
    .waitForInitialization()
    .then(() => {
      const detectSpanishCountryEnabled = ldClient.variation('detect-spanish-country', false);

      termsLinks.forEach(termsLink => {
        const spanishLink = termsLink.dataset.spanishLink;
        const englishLink = termsLink.dataset.englishLink;
        if (!spanishLink || !englishLink) {
          return;
        }

        const isSpanish = termsLink.dataset.isSpanish === 'true';

        // If feature flag is disabled, always use English link
        // If feature flag is enabled, use the link based on the cookie
        const finalLink = detectSpanishCountryEnabled && isSpanish ? spanishLink : englishLink;

        termsLink.href = finalLink;
      });
    })
    .catch(error => {
      console.error('LaunchDarkly initialization failed for terms link:', error);
      // Default to English if LaunchDarkly fails
      termsLinks.forEach(termsLink => {
        const englishLink = termsLink.dataset.englishLink;
        if (englishLink) {
          termsLink.href = englishLink;
        }
      });
    });
}

// Run on page load (handle both cases: script loaded before or after DOMContentLoaded)
if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateTermsLink);
  } else {
    // DOM already loaded, run immediately
    updateTermsLink();
  }
}
